import "./epilogue.scss"

export default function Epilogue() {
    const actData = [
        {
            title : 'ACT 1',
            desc : 'Nokheads 3D NFT Sale. Owners of the NOK will represent the spirit of the dead seeking revenge! Artwork is revealed and the spirits will be able o release rewards to hunters.'
        },
        {
            title : 'ACT 2',
            desc : 'The Hunt for clues and investigation of the mysterious disappearance of the NOK people begins on android, IOS, desktop and VR. In that order.'
        },
        {
            title : 'ACT 3',
            desc : 'The Spirits start to receive relief and retroactive drops are given to spirits that participate in the hunt.'
        },
        {
            title : 'ACT 4',
            desc : 'Hunters emerge from the past with the truth about NOK History and their rewards from the spirit of the dead.'
        },
        {
            title : 'ACT 5',
            desc : 'Real world supernatural retelling of the NOK history available in animated format. Royalty rewards are used to push floor price.'
        },
    ]
    return (
        <div className = "epilogue">
            <div className="epilogueTitle">
                <h1>EPILOGUE</h1>
            </div>
            <div className="epilogueDesc">
                <p>
                Since your journey is essentially writing the NOK story, here’s how it’s going to play out ...
                </p>
            </div>
            <div className="epilogueWrap">
                {actData.map((d) =>(
                    <div className="epilogueItem"  key = {d.title}>
                        <div className="actTitle">
                            <h2>{d.title}</h2>
                        </div>
                        <div className="actDesc">
                            <p>{d.desc}</p>
                        </div>
                    </div>
                )
                )}
                
            </div>
        </div>
    )
}
